<div class="zusammenfassung-header">
  <div class="zusammenfassung-header-text">Zusammenfassung</div>
</div>
<div class="mt-3">
  <div class="zusammenfassung-section">
    <div class="row">
      <div class="col col-xs-12 col-sm-8">
        <h6>Vertragsdaten</h6>
      </div>
      <div class="col col-xs-12 col-sm-4 text-right">
        <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#vertragsdaten', korrekturEvent)">Korrektur</button>
      </div>
      <div class="col col-xs-12 col-sm-6">
        Beginndatum:
      </div>
      <div class="col col-xs-12 col-sm-6">
        {{ !isNaN(antragComponent?.beginndatum.value) ? (antragComponent?.beginndatum.value | date) : '' }}
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="row" *ngIf="antragComponent?.laufzeit.value">
          <div class="col col-xs-12 col-sm-6">
            Laufzeit:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ antragComponent.laufzeit.value + ' Jahre' }}
          </div>
        </div>
        <div class="row" *ngIf="expertMode && antragComponent?.hauptfaelligkeitTag.value && antragComponent?.hauptfaelligkeitMonat.value">
          <div class="col col-xs-12 col-sm-6">
            Hauptfälligkeit:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ getHauptfaelligkeitString(antragComponent.hauptfaelligkeitTag.value, antragComponent.hauptfaelligkeitMonat.value) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="mt-3">
  <div class="zusammenfassung-section">
    <div class="row">
      <div class="col col-xs-12 col-sm-8">
        <h6>Versicherungsnehmer*in</h6>
      </div>
      <div class="col col-xs-12 col-sm-4 text-right">
        <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#antrag_versicherungsnehmer', korrekturEvent)">Korrektur</button>
      </div>
      <div class="col col-xs-12 col-sm-6">
        Anrede:
      </div>
      <div class="col col-xs-12 col-sm-6">
        {{ enumService.getAnrede(antragComponent?.versicherungsnehmerComponent.anrede.value) }}
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="row" *ngIf="antragComponent?.versicherungsnehmerComponent.titelPrefix.value">
          <div class="col col-xs-12 col-sm-6">
            Titel:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ dataService.getTitelPrefix().get(antragComponent.versicherungsnehmerComponent.titelPrefix.value) }}
          </div>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="row" *ngIf="antragComponent?.versicherungsnehmerComponent.showName">
          <div class="col col-xs-12 col-sm-6">
            Vorname:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ antragComponent.versicherungsnehmerComponent.vorname.value }}
          </div>
          <div class="col col-xs-12 col-sm-6">
            Nachname:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ antragComponent.versicherungsnehmerComponent.nachname.value }}
          </div>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="row" *ngIf="antragComponent?.versicherungsnehmerComponent.titelSuffix.value">
          <div class="col col-xs-12 col-sm-6">
            Titel:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ dataService.getTitelSuffix().get(antragComponent.versicherungsnehmerComponent.titelSuffix.value) }}
          </div>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="row" *ngIf="antragComponent?.versicherungsnehmerComponent.showFirmenname">
          <div class="col col-xs-12 col-sm-6">
            Firmenname:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ antragComponent.versicherungsnehmerComponent.firmenname.value }}
          </div>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-6">
        Adresse:
      </div>
      <div class="col col-xs-12 col-sm-6">
        {{ zusammenfassungService.strasseHausnummerStiegeStockTuer(antragComponent?.versicherungsnehmerComponent.adresseComponent.strasse.value, antragComponent?.versicherungsnehmerComponent.adresseComponent.hausnummer.value, antragComponent?.versicherungsnehmerComponent.adresseComponent.stiege.value, antragComponent?.versicherungsnehmerComponent.adresseComponent.stock.value, antragComponent?.versicherungsnehmerComponent.adresseComponent.tuernummer.value) }}
      </div>
      <div class="col col-xs-12 col-sm-6">
        PLZ / Ort:
      </div>
      <div class="col col-xs-12 col-sm-6">
        {{ antragComponent?.versicherungsnehmerComponent.adresseComponent.plz.value + ' ' + antragComponent?.versicherungsnehmerComponent.adresseComponent.ort.value }}
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="row" *ngIf="antragComponent?.versicherungsnehmerComponent.showGeburtsdatum">
          <div class="col col-xs-12 col-sm-6">
            Geburtsdatum:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ !isNaN(antragComponent?.versicherungsnehmerComponent.geburtsdatum.value) ? (antragComponent?.versicherungsnehmerComponent.geburtsdatum.value | date) : '' }}
          </div>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-6">
        Telefonnummer (tagsüber):
      </div>
      <div class="col col-xs-12 col-sm-6">
        {{ antragComponent?.versicherungsnehmerComponent.telefonnummer.value }}
      </div>
      <div class="col col-xs-12 col-sm-6">
        E-Mail:
      </div>
      <div class="col col-xs-12 col-sm-6">
        {{ antragComponent?.versicherungsnehmerComponent.email.value }}
      </div>
      <div class="col col-xs-12 col-sm-8 zusammenfassung-subheader" *ngIf="antragComponent?.abweichendeZustelladresse.value === 'ja'">
        <h6>Abweichende Zustelladresse</h6>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="row" *ngIf="antragComponent?.abweichendeZustelladresseArt.value === 1">
          <div class="col col-xs-12 col-sm-6">
            Adresse:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ zusammenfassungService.strasseHausnummerStiegeStockTuer(antragComponent?.abweichendeZustelladresseAdresseComponent.strasse.value, antragComponent?.abweichendeZustelladresseAdresseComponent.hausnummer.value, antragComponent?.abweichendeZustelladresseAdresseComponent.stiege.value, antragComponent?.abweichendeZustelladresseAdresseComponent.stock.value, antragComponent?.abweichendeZustelladresseAdresseComponent.tuernummer.value) }}
          </div>
          <div class="col col-xs-12 col-sm-6">
            PLZ / Ort:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ antragComponent?.abweichendeZustelladresseAdresseComponent.plz.value + ' ' + antragComponent?.abweichendeZustelladresseAdresseComponent.ort.value }}
          </div>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="row" *ngIf="antragComponent?.abweichendeZustelladresseArt.value === 2">
          <div class="col col-xs-12 col-sm-6">
            Anrede:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ enumService.getAnrede(antragComponent?.abweichendeZustelladressePersonComponent.anrede.value) }}
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="antragComponent?.abweichendeZustelladressePersonComponent.titelPrefix.value">
              <div class="col col-xs-12 col-sm-6">
                Titel:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ dataService.getTitelPrefix().get(antragComponent.abweichendeZustelladressePersonComponent.titelPrefix.value) }}
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="antragComponent?.abweichendeZustelladressePersonComponent.showName">
              <div class="col col-xs-12 col-sm-6">
                Vorname:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ antragComponent.abweichendeZustelladressePersonComponent.vorname.value }}
              </div>
              <div class="col col-xs-12 col-sm-6">
                Nachname:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ antragComponent.abweichendeZustelladressePersonComponent.nachname.value }}
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="antragComponent?.abweichendeZustelladressePersonComponent.titelSuffix.value">
              <div class="col col-xs-12 col-sm-6">
                Titel:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ dataService.getTitelSuffix().get(antragComponent?.abweichendeZustelladressePersonComponent.titelSuffix.value) }}
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="antragComponent?.abweichendeZustelladressePersonComponent.showFirmenname">
              <div class="col col-xs-12 col-sm-6">
                Firmenname:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ antragComponent.abweichendeZustelladressePersonComponent.firmenname.value }}
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-6">
            Adresse:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ zusammenfassungService.strasseHausnummerStiegeStockTuer(antragComponent?.abweichendeZustelladressePersonComponent.adresseComponent.strasse.value, antragComponent?.abweichendeZustelladressePersonComponent.adresseComponent.hausnummer.value, antragComponent?.abweichendeZustelladressePersonComponent.adresseComponent.stiege.value, antragComponent?.abweichendeZustelladressePersonComponent.adresseComponent.stock.value, antragComponent?.abweichendeZustelladressePersonComponent.adresseComponent.tuernummer.value) }}
          </div>
          <div class="col col-xs-12 col-sm-6">
            PLZ / Ort:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ antragComponent?.abweichendeZustelladressePersonComponent.adresseComponent.plz.value + ' ' + antragComponent?.abweichendeZustelladressePersonComponent.adresseComponent.ort.value }}
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="antragComponent?.abweichendeZustelladressePersonComponent.showGeburtsdatum">
              <div class="col col-xs-12 col-sm-6">
                Geburtsdatum:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ !isNaN(antragComponent?.abweichendeZustelladressePersonComponent.geburtsdatum.value) ? (antragComponent?.abweichendeZustelladressePersonComponent.geburtsdatum.value | date) : '' }}
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-6">
            Telefonnummer (tagsüber):
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ antragComponent?.abweichendeZustelladressePersonComponent.telefonnummer.value }}
          </div>
          <div class="col col-x.versicherungsnehmerComponents-12 col-sm-6">
            E-Mail:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ antragComponent?.abweichendeZustelladressePersonComponent.email.value }}
          </div>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-8 zusammenfassung-subheader" *ngIf="antragComponent?.abweichenderPraemienzahler.value === 'ja'">
        <h6>Abweichender Prämienzahler</h6>
      </div>
      <div class="col col-xs-12 col-sm-6" *ngIf="antragComponent?.abweichenderPraemienzahler.value === 'ja'"></div>
      <div class="col col-xs-12 col-sm-6" *ngIf="antragComponent?.abweichenderPraemienzahler.value === 'nein'">
        Abweichender Prämienzahler?
      </div>
      <div class="col col-xs-12 col-sm-6" *ngIf="antragComponent?.abweichenderPraemienzahler.value === 'nein'">
        {{ antragComponent?.abweichenderPraemienzahler.value | toCapLetter }}
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="row" *ngIf="antragComponent?.abweichenderPraemienzahler.value === 'ja'">
          <div class="col col-xs-12 col-sm-6">
            Anrede:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ enumService.getAnrede(antragComponent?.praemienzahlerComponent.anrede.value) }}
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="antragComponent?.praemienzahlerComponent.titelPrefix.value">
              <div class="col col-xs-12 col-sm-6">
                Titel:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ dataService.getTitelPrefix().get(antragComponent.praemienzahlerComponent.titelPrefix.value) }}
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="antragComponent?.praemienzahlerComponent.showName">
              <div class="col col-xs-12 col-sm-6">
                Vorname:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ antragComponent.praemienzahlerComponent.vorname.value }}
              </div>
              <div class="col col-xs-12 col-sm-6">
                Nachname:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ antragComponent.praemienzahlerComponent.nachname.value }}
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="antragComponent?.praemienzahlerComponent.titelSuffix.value">
              <div class="col col-xs-12 col-sm-6">
                Titel:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ dataService.getTitelSuffix().get(antragComponent?.praemienzahlerComponent.titelSuffix.value) }}
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="antragComponent?.praemienzahlerComponent.showFirmenname">
              <div class="col col-xs-12 col-sm-6">
                Firmenname:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ antragComponent.praemienzahlerComponent.firmenname.value }}
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-6">
            Adresse:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ zusammenfassungService.strasseHausnummerStiegeStockTuer(antragComponent?.praemienzahlerComponent.adresseComponent.strasse.value, antragComponent?.praemienzahlerComponent.adresseComponent.hausnummer.value, antragComponent?.praemienzahlerComponent.adresseComponent.stiege.value, antragComponent?.praemienzahlerComponent.adresseComponent.stock.value, antragComponent?.praemienzahlerComponent.adresseComponent.tuernummer.value) }}
          </div>
          <div class="col col-xs-12 col-sm-6">
            PLZ / Ort:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ antragComponent?.praemienzahlerComponent.adresseComponent.plz.value + ' ' + antragComponent?.praemienzahlerComponent.adresseComponent.ort.value }}
          </div>
          <div class="col col-xs-12 col-sm-12">
            <div class="row" *ngIf="antragComponent?.praemienzahlerComponent.showGeburtsdatum">
              <div class="col col-xs-12 col-sm-6">
                Geburtsdatum:
              </div>
              <div class="col col-xs-12 col-sm-6">
                {{ !isNaN(antragComponent?.praemienzahlerComponent.geburtsdatum.value) ? (antragComponent?.praemienzahlerComponent.geburtsdatum.value | date) : '' }}
              </div>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-6">
            Telefonnummer (tagsüber):
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ antragComponent?.praemienzahlerComponent.telefonnummer.value }}
          </div>
          <div class="col col-x.versicherungsnehmerComponents-12 col-sm-6">
            E-Mail:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ antragComponent?.praemienzahlerComponent.email.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="antragComponent?.abweichenderVersicherungsort.value === 2">
  <div class="mt-3">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Versicherungsort</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#versicherungsort_adresse', korrekturEvent)">Korrektur</button>
        </div>
        <div class="col col-xs-12 col-sm-6">
          Adresse:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ zusammenfassungService.strasseHausnummerStiegeStockTuer(antragComponent.versicherungsortComponent.strasse.value, antragComponent.versicherungsortComponent.hausnummer.value, antragComponent.versicherungsortComponent.stiege.value, antragComponent.versicherungsortComponent.stock.value, antragComponent.versicherungsortComponent.tuernummer.value) }}
        </div>
        <div class="col col-xs-12 col-sm-6">
          PLZ / Ort:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ (antragComponent.versicherungsortComponent.plz.value || '') + ' ' + (antragComponent.versicherungsortComponent.ort.value || '') }}
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="antragComponent?.weitereWohneinheiten.value === 'ja'">
  <div class="mt-3" *ngIf="antragComponent?.zweiteWohneinheitComponent.strasse.value">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Zweite Wohneinheit (prämienfrei)</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#zweiteWohneinheit_adresse', korrekturEvent)">Korrektur</button>
        </div>
        <div class="col col-xs-12 col-sm-6">
          Adresse:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ zusammenfassungService.strasseHausnummerStiegeStockTuer(antragComponent.zweiteWohneinheitComponent.strasse.value, antragComponent.zweiteWohneinheitComponent.hausnummer.value, antragComponent.zweiteWohneinheitComponent.stiege.value, antragComponent.zweiteWohneinheitComponent.stock.value, antragComponent.zweiteWohneinheitComponent.tuernummer.value) }}
        </div>
        <div class="col col-xs-12 col-sm-6">
          PLZ / Ort:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ (antragComponent.zweiteWohneinheitComponent.plz.value || '') + ' ' + (antragComponent.zweiteWohneinheitComponent.ort.value || '') }}
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3" *ngIf="antragComponent?.dritteWohneinheitComponent.strasse.value">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Dritte Wohneinheit (prämienfrei)</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#dritteWohneinheit_adresse', korrekturEvent)">Korrektur</button>
        </div>
        <div class="col col-xs-12 col-sm-6">
          Adresse:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ zusammenfassungService.strasseHausnummerStiegeStockTuer(antragComponent?.dritteWohneinheitComponent.strasse.value, antragComponent?.dritteWohneinheitComponent.hausnummer.value, antragComponent?.dritteWohneinheitComponent.stiege.value, antragComponent?.dritteWohneinheitComponent.stock.value, antragComponent?.dritteWohneinheitComponent.tuernummer.value) }}
        </div>
        <div class="col col-xs-12 col-sm-6">
          PLZ / Ort:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ (antragComponent?.dritteWohneinheitComponent.plz.value || '') + ' ' + (antragComponent?.dritteWohneinheitComponent.ort.value || '') }}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="mt-3">
  <div class="zusammenfassung-section">
    <div class="row">
      <div class="col col-xs-12 col-sm-8">
        <h6>Prämienzahlung</h6>
      </div>
      <div class="col col-xs-12 col-sm-4 text-right">
        <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#antrag_praemienzahlung', korrekturEvent)">Korrektur</button>
      </div>
      <div class="col col-xs-12 col-sm-6">
        Zahlungsart:
      </div>
      <div class="col col-xs-12 col-sm-6">
        {{ antragComponent?.zahlungsweise.value === 1 ? 'Zahlschein' : antragComponent?.zahlungsweise.value === 2 ? 'SEPA-Lastschrift' : '' }}
      </div>
      <div class="col col-xs-12 col-sm-6">
        Zahlungsweise:
      </div>
      <div class="col col-xs-12 col-sm-6">
        {{ antragComponent?.zahlungsart.value?.Value }}
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="row" *ngIf="antragComponent?.iban.value">
          <div class="col col-xs-12 col-sm-6">
            IBAN:
          </div>
          <div class="col col-xs-12 col-sm-6">
            {{ antragComponent.iban.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
